export const StylingObject = {
    // When Select Tag is disabled then its label show dark from normal disabled textField 
    // there is not a way for changing that from css so styling needs to pass from object form in mui InputLabel;
    disabledSelectLabel:{
        fontWeight:400,
        opacity:0.6
    }
}